const baloonClass = 'balloon';

export const showBalloon = (event,message) => {
    let elem = event.target;
    let balloon = document.createElement('span');
    balloon.className = baloonClass;
    balloon.innerHTML = message;
    balloon.style.zIndex = '1000';
    balloon.style.position = 'fixed';
    let rect = elem.getBoundingClientRect();
    balloon.style.top = String(rect.top + rect.height + 5) + 'px';
    balloon.style.left = String(elem.getBoundingClientRect().left) + 'px';
    document.body.appendChild(balloon);
}
export const closeBalloon = (event) => {
    let balloons = document.getElementsByClassName(baloonClass);
    for (let i=0;i<balloons.length;i++) {
        document.body.removeChild(balloons[i]);
    }
}
